if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
	  const freeshippingBar = this.getAttribute('data-show-bar');
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
	  const hasSubscription = document.querySelectorAll('.selling-plan-name').length > 0;
	  const progressPercent = hasSubscription ? 100 : Math.min((cartTotal / freeShippingThreshold) * 100, 100);
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingSuccess = false 
	  
	  if (hasSubscription) {
		shippingMessage = "Subscription orders <strong>ship free</strong>. Nothing to unlock.";
		shippingSuccess = true;
	  }
      else if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
		if(freeshippingBar == 'true'){
			// const progressPercent = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
			// PK: mark the finished state so the drawer can drop the (meaningless) full bar.
			this.classList.toggle('is-complete', shippingSuccess);
			this.innerHTML = `
				<div class="shipping-progress-wrapper">
					<div class="shipping-progress-bar">
						<div class="shipping-progress-fill" style="width:${progressPercent}%"></div>
					</div>
					<p class="shipping-progress-text">
						<span class="shipping-copy">${shippingMessage}</span>
						<span class="shipping-icon" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 5.5h9v8H2zM11 8h4l3 3v2.5h-7"></path><circle cx="5.5" cy="15.5" r="1.7"></circle><circle cx="14.5" cy="15.5" r="1.7"></circle></svg></span>
					</p>
				</div>
			`;
		}else{
			this.innerHTML = shippingMessage;
		}
      }

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}